const AdminHighlight = () => {
  return (
    <div>
      <h1>Admin Highlight</h1>
    </div>
  );
};

export default AdminHighlight;
